import { AuthenticatedSession } from '@/authenticatedSession/authenticatedSession';
import { isYearMonthDay, ymdToString } from '@/database/yearMonthDayUtil';
import { TimeEntryData, TimeEntryEvent } from '@shared/types';

export const auditingEventForTimeEntryField = (props: {
  field: keyof TimeEntryData;
  previousValue: TimeEntryData[keyof TimeEntryData];
  value: TimeEntryData[keyof TimeEntryData];
  authSession: AuthenticatedSession | undefined;
  userMap: {
    [userId: string]: { fullName: string; lastName: string; firstName: string };
  };
}): TimeEntryEvent => {
  const { field, previousValue, value, authSession, userMap } = props;

  if (field === 'user') {
    const fromUser =
      userMap?.[(previousValue as string) ?? '']?.fullName ?? 'unassigned';
    const toUser = userMap?.[(value as string) ?? '']?.fullName ?? 'unassigned';
    return {
      type: 'modified',
      timestamp: new Date(),
      userId: authSession?.userIds.firestore || '',
      details: `Timekeeper changed from ${fromUser} to ${toUser}`,
    };
  }

  const valueAsString = (v: unknown) => {
    if (v === undefined || v === null) return 'none';
    if (typeof v === 'string') return v.trim() === '' ? 'none' : v;
    if (typeof v === 'number') return String(v);
    if (isYearMonthDay(v)) return ymdToString({ ymd: v, format: 'MM/dd/yyyy' });
    return String(v);
  };

  return {
    type: 'modified',
    timestamp: new Date(),
    userId: authSession?.userIds.firestore || '',
    details: `${field} changed from ${valueAsString(previousValue)} to ${valueAsString(value)}`,
  };
};
